export * from './projectExperienceGroup.service';
import { ProjectExperienceGroupService } from './projectExperienceGroup.service';
export * from './projectExperienceGroup.serviceInterface';
export const APIS = [ProjectExperienceGroupService];
